import { request } from '@/utils/request';
import * as url from '@/src/constant';

const ROUTE_USER = '/pages/user/index';

// 账号注销
export function updateAccountStatus(query) {
  return request({
    url: url.UPDATE_ACCOUNT_STATUS_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_USER,
    // message问题已修复
    showToast: false,
  });
}

// 确认实名信息
export function fetchConfirmRealnameResult(query) {
  return request({
    url: url.QUERY_REALNAME_CONFIRM_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_USER,
    // message问题已修复
    showToast: false,
  });
}

// 校验灵工入驻状态
export function fetchUserSettleStatus(query) {
  return request({
    url: url.SETTLE_STATUS_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_USER,
  });
}

/**
 * 获取实名信息
 * @param query
 * @returns {Promise<TResult>}
 */
export function fetchRealnameInfo(query) {
  return request({
    url: url.QUERY_REALNAMEINFO_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_USER,
  });
}

/**
 * 获取灵工账户信息
 * @param query
 * @returns {Promise<TResult>}
 */
export function fetchAccountInfo(query) {
  return request({
    url: url.QUERY_ACCOUNTINFO_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_USER,
  });
}

/**
 * 获取佣金结算账户信息
 * @param query
 * @returns {Promise<TResult>}
 */
export function fetchSalaryAccountInfo(query) {
  return request({
    url: url.QUERY_SALARY_ACCOUNTINFO_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_USER,
    // message不需要处理
    showToast: false,
  });
}

/**
 * 开通灵工账户
 * @param query
 * @returns {Promise<TResult>}
 */
export function createAccount(query, header = {}) {
  return request({
    url: url.REGISTER_URL,
    method: 'POST',
    query,
    header,
    returnUrl: ROUTE_USER,
  });
}

/**
 * 判断灵工是否已绑定该企业
 * @param query
 * @returns {Promise<TResult>}
 */
export function isBindEmployer(query, header = {}) {
  return request({
    url: url.IS_BIND_EMPLOYER,
    method: 'POST',
    query,
    header,
    returnUrl: ROUTE_USER,
  });
}

/**
 * 【5.18.0】【聂】根据cid查询企业名称
 * @param query
 * @returns {Promise<TResult>}
 */
export function queryEntName(query, header = {}) {
  return request({
    url: url.QUERY_ENT_NAME,
    method: 'POST',
    query,
    header,
    returnUrl: ROUTE_USER,
  });
}

/**
 * 【5.18.0】【邓加国】绑定企业灵工关系
 * @param query
 * @returns {Promise<TResult>}
 */
export function bindEmployer(query, header = {}) {
  return request({
    url: url.BIND_EMPLOYER,
    method: 'POST',
    query,
    header,
    returnUrl: ROUTE_USER,
  });
}

export function employerList(query, header = {}) {
  return request({
    url: '/api/freelancer/sign/employerList',
    method: 'POST',
    query,
    header,
    returnUrl: '/pages/employer/index',
  });
}
export function contractSignDetail(query, header = {}) {
  return request({
    url: '/api/freelancer/sign/contractSignDetail',
    method: 'POST',
    query,
    header,
    returnUrl: '/pages/employer-contract/index',
  });
}
